import { Typography } from 'omakase';

interface Props {
  title: string;
}

const ReservationTitle = ({ title }: Props) => {
  return (
    <Typography variant="body01Strong" className="u-truncatedText">
      {title}
    </Typography>
  );
};

export default ReservationTitle;
